import React from 'react';
import { Chart } from 'react-google-charts';

var heartbeat_data = [
  [
    { type: 'datetime', label: 'Time of Day' },
    { type: 'number', label: 'Device heartbeat'},
  ],
  [new Date(2015, 0, 1, 0, 0), 0], [new Date(2015, 0, 1, 0, 3), 0],
  [new Date(2015, 0, 1, 0, 6), 1], [new Date(2015, 0, 1, 0, 9), 1],
  [new Date(2015, 0, 1, 0, 12), 1],  [new Date(2015, 0, 1, 0, 15), 1],
  [new Date(2015, 0, 1, 0, 18), 1],    [new Date(2015, 0, 1, 0, 21), 1],
  [new Date(2015, 0, 1, 0, 24), 1],    [new Date(2015, 0, 1, 0, 27), 1],
  [new Date(2015, 0, 1, 0, 30), 1],  [new Date(2015, 0, 1, 0, 33), 1],
  [new Date(2015, 0, 1, 0, 36), 1],   [new Date(2015, 0, 1, 0, 39), 1],
  [new Date(2015, 0, 1, 0, 42), 1], [new Date(2015, 0, 1, 0, 45), 0], [new Date(2015, 0, 1, 0, 48), 0],
  [new Date(2015, 0, 1, 0, 51), 0],   [new Date(2015, 0, 1, 0, 54), 0],
  [new Date(2015, 0, 1, 0, 57), 0], [new Date(2015, 0, 1, 1, 0), 0],
  [new Date(2015, 0, 1, 1, 3), 1], [new Date(2015, 0, 1, 1, 6), 1],
  [new Date(2015, 0, 1, 1, 9), 1],   [new Date(2015, 0, 1, 1, 12), 1],
  [new Date(2015, 0, 1, 1, 15), 1], [new Date(2015, 0, 1, 1, 18), 0],
  [new Date(2015, 0, 1, 1, 21), 0],  [new Date(2015, 0, 1, 1, 23), 1],
  [new Date(2015, 0, 1, 1, 27), 0],  [new Date(2015, 0, 1, 1, 30), 0],
  [new Date(2015, 0, 1, 1, 33), 0],    [new Date(2015, 0, 1, 1, 36), 1],
  [new Date(2015, 0, 1, 1, 39), 1],  [new Date(2015, 0, 1, 1, 42), 1],
];
var heartbeat_ticks = [0, 1];

var alarms_data = [
  [
    { type: 'datetime', label: 'Time of Day' },
    { type: 'number', label: 'info'},
    { type: 'number', label: 'warning'},
    { type: 'number', label: 'critical'},
  ],
  [new Date(2015, 0, 1, 0, 0), 0, 0, 0], [new Date(2015, 0, 1, 0, 3), 1, 0, 0],
  [new Date(2015, 0, 1, 0, 6), 1, 0, 0], [new Date(2015, 0, 1, 0, 9), 1, 2, 0],
  [new Date(2015, 0, 1, 0, 12), 1, 2, 0],  [new Date(2015, 0, 1, 0, 15), 0, 2, 0],
  [new Date(2015, 0, 1, 0, 18), 0, 2, 3],    [new Date(2015, 0, 1, 0, 21), 0, 2, 3],
  [new Date(2015, 0, 1, 0, 24), 0, 2, 3],    [new Date(2015, 0, 1, 0, 27), 0, 2, 3],
  [new Date(2015, 0, 1, 0, 30), 1, 0, 3],  [new Date(2015, 0, 1, 0, 33), 1, 0, 3],
  [new Date(2015, 0, 1, 0, 36), 1, 0, 0],   [new Date(2015, 0, 1, 0, 39), 0, 0, 0],
  [new Date(2015, 0, 1, 0, 42), 0, 0, 3], [new Date(2015, 0, 1, 0, 45), 0, 0, 3], [new Date(2015, 0, 1, 0, 48), 0, 2, 3],
  [new Date(2015, 0, 1, 0, 51), 0, 2, 3],   [new Date(2015, 0, 1, 0, 54), 0, 2, 3],
  [new Date(2015, 0, 1, 0, 57), 0, 2, 3], [new Date(2015, 0, 1, 1, 0), 0, 2, 3],
  [new Date(2015, 0, 1, 1, 3), 1, 0, 3], [new Date(2015, 0, 1, 1, 6), 1, 0, 3],
  [new Date(2015, 0, 1, 1, 9), 1, 0, 3],   [new Date(2015, 0, 1, 1, 12), 1, 0, 3],
  [new Date(2015, 0, 1, 1, 15), 0, 2, 3], [new Date(2015, 0, 1, 1, 18), 0, 2, 3],
  [new Date(2015, 0, 1, 1, 21), 0, 2, 3],  [new Date(2015, 0, 1, 1, 23), 0, 2, 3],
  [new Date(2015, 0, 1, 1, 27), 0, 2, 3],  [new Date(2015, 0, 1, 1, 30), 0, 2, 3],
  [new Date(2015, 0, 1, 1, 33), 0, 2, 3],    [new Date(2015, 0, 1, 1, 36), 0, 2, 3],
  [new Date(2015, 0, 1, 1, 39), 1, 2, 3],  [new Date(2015, 0, 1, 1, 42), 1, 2, 3],
];
var alarms_ticks = [0, 1, 2, 3];

var system_data = [
  [
    { type: 'datetime', label: 'Time of Day' },
    { type: 'number', label: 'Temp C'},
    { type: 'number', label: 'Memory %'},
    { type: 'number', label: 'Bandwidth mbps'},
  ],
  [new Date(2015, 0, 1, 0, 0), 23, 45, 20], [new Date(2015, 0, 1, 0, 3), 25, 48, 16],
  [new Date(2015, 0, 1, 0, 6), 22, 43, 17], [new Date(2015, 0, 1, 0, 9), 21, 41, 18],
  [new Date(2015, 0, 1, 0, 12), 22, 45, 17],  [new Date(2015, 0, 1, 0, 15), 21, 45, 14],
  [new Date(2015, 0, 1, 0, 18), 26, 41, 16],    [new Date(2015, 0, 1, 0, 21), 23, 41, 16],
  [new Date(2015, 0, 1, 0, 24), 20, 41, 15],    [new Date(2015, 0, 1, 0, 27), 22, 42, 16],
  [new Date(2015, 0, 1, 0, 30), 25, 45, 19],  [new Date(2015, 0, 1, 0, 33), 24, 45, 20],
  [new Date(2015, 0, 1, 0, 36), 23, 42, 18],   [new Date(2015, 0, 1, 0, 39), 24, 41, 15],
  [new Date(2015, 0, 1, 0, 42), 21, 41, 17], [new Date(2015, 0, 1, 0, 45), 22, 42, 20], [new Date(2015, 0, 1, 0, 48), 21, 41, 15],
  [new Date(2015, 0, 1, 0, 51), 20, 44, 15],   [new Date(2015, 0, 1, 0, 54), 25, 45, 13],
  [new Date(2015, 0, 1, 0, 57), 24, 41, 14], [new Date(2015, 0, 1, 1, 0), 23, 42, 16],
  [new Date(2015, 0, 1, 1, 3), 24, 41, 16], [new Date(2015, 0, 1, 1, 6), 24, 41, 16],
  [new Date(2015, 0, 1, 1, 9), 24, 45, 18],   [new Date(2015, 0, 1, 1, 12), 23, 44, 18],
  [new Date(2015, 0, 1, 1, 15), 24, 44, 14], [new Date(2015, 0, 1, 1, 18), 24, 44, 44],
  [new Date(2015, 0, 1, 1, 21), 24, 45, 15],  [new Date(2015, 0, 1, 1, 23), 25, 45, 16],
  [new Date(2015, 0, 1, 1, 27), 23, 43, 17],  [new Date(2015, 0, 1, 1, 30), 24, 45, 12],
  [new Date(2015, 0, 1, 1, 33), 24, 44, 17],    [new Date(2015, 0, 1, 1, 36), 23, 44, 15],
  [new Date(2015, 0, 1, 1, 39), 24, 44, 14],  [new Date(2015, 0, 1, 1, 42), 21, 41, 20],
];
var system_ticks = 'auto';


export default class DeviceCharts extends React.Component {
  render() {
    var ticks = this.props.chartData === 'Hearbeat'? heartbeat_ticks
      :this.props.chartData === 'Alarms'? alarms_ticks
        : this.props.chartData === 'Alarms'? system_ticks
          :heartbeat_ticks;
    return (
      <div className={'my-pretty-chart-container'}>
        <div>
          <Chart
            width={'100%'}
            height={'200px'}
            chartType="Line"
            loader={<div>Loading Chart</div>}
            data={this.props.chartData === 'Hearbeat'? heartbeat_data
              :this.props.chartData === 'Alarms'? alarms_data
                :this.props.chartData === 'System'? system_data
                  :heartbeat_data}
            options = {{
              legend:{
                position:'in',
              },
              hAxis: {
                viewWindow: {
                  min: new Date(2014, 11, 31, 18, 0),
                  max: new Date(2015, 0, 3, 1, 57)
                },
                gridlines: {
                  count: -1,
                  units: {
                    days: {format: ['MMM dd']},
                    hours: {format: ['HH:mm', 'ha']},
                  }
                },
                minorGridlines: {
                  units: {
                    hours: {format: ['hh:mm:ss a', 'ha']},
                    minutes: {format: ['HH:mm a Z', ':mm']}
                  }
                }
              },
              vAxis: {
                ticks: ticks,
              },
              series: {
                0: { color: 'blue' },
                1: { color: 'orange' },
                2: { color: 'red' },
              },
            }}
            rootProps={{ 'data-testid': '4' }}
          />
        </div>
      </div>
    );
  }
}